export default "__VITE_ASSET__e18dd3e7__"